module.exports = __webpack_public_path__ + "static/1-Son Principal Ambiance Gym-07a09ca460815526d47c4d51a596370b.mp3";